import router from '../router'

export default {
  state: {
    list: [],
    filters: {
      country: null,
      status: 'All',
      title: ''
    },
    pagination: {},
    formSurvey: {
      title: {},
      country_id: void 0,
      status: void 0,
      questions: []
    },
  },
  mutations: {
    setSurveys(state, payload) {
      state.list = payload
    },
    setSurveyForm(state, payload) {
      state.formSurvey = payload
    },
    setSurveysFilters(state, payload) {
      state.filters = payload
    },
    setSurveysPagination(state, payload) {
      state.pagination = payload
    },
  },
  actions: {
    querySurveys({state, dispatch, commit}) {
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'polls', {params: state.filters})
        .then(res => {
          commit('setSurveys', res.data.polls)
          commit('setSurveysPagination', res.data.pagination)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    querySurvey({state, dispatch, commit}, payload) {
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'polls/' + payload)
        .then(res => {
          commit('setSurveyForm', res.data)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    storeSurvey({dispatch, commit}, payload) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'polls', payload)
        .then(res => {
          dispatch('setPreloader', false)
          dispatch('setToast', {status: 'success', message: res.data.message})
          router.push('/surveys/' + res.data.poll.id)
          dispatch('querySurvey', res.data.poll.id)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    copySurvey({dispatch, commit}, payload) {
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'poll-copy/' + payload)
        .then(res => {
          dispatch('setPreloader', false)
          dispatch('setToast', {status: 'success', message: res.data.message})
          router.push('/surveys/' + res.data.poll.id)
          dispatch('querySurvey', res.data.poll.id)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    updateSurvey({dispatch, commit}, payload) {
      axios.patch(process.env.VUE_APP_API_ENDPOINT + 'polls/' + payload[0], payload[1])
        .then(res => {
          dispatch('setToast', {status: 'success', message: res.data.message})
          dispatch('querySurveys')
          dispatch('querySurvey', payload[0])
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    destroySurvey({dispatch, commit}, payload) {
      dispatch('setPreloader', true)
      axios.delete(process.env.VUE_APP_API_ENDPOINT + 'polls/' + payload)
        .then(res => {
          dispatch('querySurveys')
          dispatch('setToast', {status: 'success', message: res.data.message})
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    clearSurveyForm({commit}) {
      commit('setSurveyForm', {
        title: {},
        country_id: void 0,
        status: void 0,
        questions: []
      })
    },
    updateSurveyFormQuestion({dispatch, commit}, payload) {
      dispatch('setPreloader', true)
      axios.patch(process.env.VUE_APP_API_ENDPOINT + 'questions/' + payload[0], payload[1])
        .then(res => {
          dispatch('querySurvey', payload[1].poll_id)
          dispatch('setToast', {status: 'success', message: res.data.message})
          dispatch('closeModal', true)
          dispatch('setPreloader', false)
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    }
  },
  getters: {
    getSurveys: state => {
      return state.list
    },
    getSurveyForm: state => {
      return state.formSurvey
    },
    getSurveyFilters: state => {
      return state.filters
    },
    getSurveysPagination: state => {
      return state.pagination
    },
    getPublicSurvayFromRegion: state => {
      return (region) => {
        for (let item of state.list)
          if (item.country_id == region && item.status)
            return item.id
        return false
      }
    }
  }
}